import _invariant from 'invariant';
import PropTypes  from 'prop-types';
import {
  compose,
  mapProps,
  setDisplayName,
  wrapDisplayName,
}                 from 'recompose';
import _          from 'underscore';


/**
 * HOC to filter props, either by blacklist or whitelist.
 *
 * @param {?array}    blacklist      Array of props to remove.
 * @param {?array}    whitelist      Array of props to keep.
 * @param {?function} innerComponent Component to use in the display name.
 *
 * @return {*}
 */
export const filterProps = ({blacklist = null, whitelist = null, innerComponent = null}) => {

  PropTypes.checkPropTypes(
    {
      blackList:      PropTypes.arrayOf(PropTypes.string),
      whitelist:      PropTypes.arrayOf(PropTypes.string),
      innerComponent: PropTypes.func,
    },
    {blacklist, whitelist, innerComponent},
    'args',
    'filterProps'
  );

  _invariant(
    blacklist || whitelist,
    'You must provide wither a blacklist or a whitelist'
  );

  if (blacklist) {

    return compose(
      setDisplayName((innerComponent && wrapDisplayName(innerComponent, 'BlacklistProps')) || 'BlacklistProps'),
      mapProps(props => _.omit(props, blacklist))
    );

  }

  if (whitelist) {

    return compose(
      setDisplayName((innerComponent && wrapDisplayName(innerComponent, 'WhitelistProps')) || 'WhitelistProps'),
      mapProps(props => _.pick(props, whitelist))
    );

  }

  throw new Error('You should never get here!');

};


// WEBPACK FOOTER //
// ./src/components/HOC/filterProps.js